import React from 'react';

import { MdModeEdit, MdDelete, MdCheck } from 'react-icons/md';

import history from '~/services/history';

const columnSca = () => {
  const editarLinha = (id, data) => {
    history.push({
      pathname: `/formulario-linhas-de-cuidado/${data.linhaDeCuidadoValue}`,
      state: {
        periodo: data.periodoSelecionado,
        indicador: data.linhaDeCuidadoValue,
        indicadorNome: data.linhaDeCuidado,
        idRecord: Number(id),
        id: Number(id),
      },
    });
  };

  const deletarLinha = (id, data) => {
    history.push({
      pathname: `/linha-de-cuidado/${data.linhaDeCuidadoValue}`,
      state: {
        periodo: data.periodoSelecionado,
        indicador: data.linhaDeCuidadoValue,
        indicadorNome: data.linhaDeCuidado,
        deleteLinha: Number(id),
      },
    });
  };

  return [
    {
      title: 'Número do registro',
      dataIndex: 'num_registro_sca',
      key: 'num_registro_sca',
      width: 170,
      sorter: (a, b) => a.num_registro_sca - b.num_registro_sca,
      sortDirections: ['descend', 'ascend'],
    },
    {
      title: 'Identificador do paciente',
      dataIndex: 'identificadordoPaciente',
      key: 'identificadordoPaciente',
      width: 210,
    },

    {
      title: 'Completo',
      key: 'completo',
      dataIndex: 'completo',
      width: 120,
      sorter: (a, b) => a.completo - b.completo,
      sortDirections: ['descend', 'ascend'],
      render: (id, data) => {
        return (
          <div>{data.completo && <MdCheck size={20} color="#74a50a" />}</div>
        );
      },
    },
    {
      title: '',
      key: 'id',
      dataIndex: 'id',
      width: 210,
      render: (id, data) => {
        return (
          <div className="botoesGrid">
            <button type="button" onClick={() => editarLinha(id, data)}>
              <MdModeEdit size={18} />
              Editar
            </button>
            <button
              type="button"
              className="btn-remove"
              onClick={() => deletarLinha(id, data)}
            >
              <MdDelete size={18} />
              Excluir
            </button>
          </div>
        );
      },
    },

    {
      title: 'Sexo',
      dataIndex: 'sexo_sca_descritivo',
      key: 'sexo_sca',
      width: 100,
    },

    {
      title: 'Data de nascimento',
      dataIndex: 'dn_sca',
      key: 'dn_sca',
      width: 120,
    },

    {
      title: 'Convênio do paciente',
      dataIndex: 'convenio_sca_descritivo',
      key: 'convenio_sca',
      width: 130,
    },

    {
      title: 'Data do início dos sintomas',
      dataIndex: 'sintomas_data_sca',
      key: 'sintomas_data_sca',
      width: 130,
    },
    {
      title: 'Hora do início dos sintomas',
      dataIndex: 'sintomas_hora_sca',
      key: 'sintomas_hora_sca',
      width: 130,
    },
    {
      title: 'Paciente proveniente de outra instituição',
      dataIndex: 'outra_instituicao_sca_descritivo',
      key: 'outra_instituicao_sca',
      width: 160,
    },
    {
      title: 'Data da chegada na instituição',
      dataIndex: 'entrada_data_sca',
      key: 'entrada_data_sca',
      width: 130,
    },

    {
      title: 'Hora da chegada na instituição',
      dataIndex: 'entrada_hora_sca',
      key: 'entrada_hora_sca',
      width: 130,
    },

    {
      title: 'Data da realização do primeiro eletrocardiograma na instituição',
      dataIndex: 'ecg_data_sca',
      key: 'ecg_data_sca',
      width: 250,
    },

    {
      title: 'Hora da realização do primeiro eletrocardiograma na instituição',
      dataIndex: 'ecg_hora_sca',
      key: 'ecg_hora_sca',
      width: 250,
    },

    {
      title: 'Classificação da SCA',
      dataIndex: 'classificacao_sca_descritivo',
      key: 'classificacao_sca',
      width: 170,
    },

    {
      title: 'Frequência cardíaca/pulso na admissão',
      dataIndex: 'fc_sca',
      key: 'fc_sca',
      width: 200,
    },

    {
      title: 'Pressão arterial sistólica na admissão',
      dataIndex: 'pas_sca',
      key: 'pas_sca',
      width: 200,
    },

    {
      title: 'Creatinina sérica na admissão',
      dataIndex: 'creatinina_sca',
      key: 'creatinina_sca',
      width: 130,
    },

    {
      title:
        'Parada cardiorrespiratória relacionada ao quadro atual (do início dos sintomas até a admissão hospitalar)',
      dataIndex: 'pcr_sca_descritivo',
      key: 'pcr_sca',
      width: 280,
    },

    {
      title: 'Alteração de marcadores de lesão cardíaca (troponina ou CK-MB)',
      dataIndex: 'enzimas_sca_descritivo',
      key: 'enzimas_sca',
      width: 280,
    },

    {
      title: 'Classificação de Killip',
      dataIndex: 'killip_sca_descritivo',
      key: 'killip_sca',
      width: 200,
    },

    {
      title: 'Eletrocardiograma com desvio do segmento ST',
      dataIndex: 'st_sca_descritivo',
      key: 'st_sca',
      width: 180,
    },

    {
      title: 'Escore de Grace',
      dataIndex: 'grace_sca',
      key: 'grace_sca',
      width: 130,
    },

    {
      title: 'Tratamento realizado',
      dataIndex: 'tto_sca_descritivo',
      key: 'tto_sca',
      width: 130,
    },

    {
      title: 'Data da realização da terapia fibrinolítica',
      dataIndex: 'fibrinolitico_data_sca',
      key: 'fibrinolitico_data_sca',
      width: 200,
    },

    {
      title: 'Hora da realização da terapia fibrinolítica',
      dataIndex: 'fibrinolitico_hora_sca',
      key: 'fibrinolitico_hora_sca',
      width: 200,
    },

    {
      title: 'Data da realização da angioplastia',
      dataIndex: 'angioplastia_data_sca',
      key: 'angioplastia_data_sca',
      width: 150,
    },

    {
      title: 'Hora da realização da angioplastia',
      dataIndex: 'angioplastia_hora_sca',
      key: 'angioplastia_hora_sca',
      width: 150,
    },

    {
      title:
        'Fração de ejeção do ventrículo esquerdo em exame realizado durante a internação',
      dataIndex: 'fe_sca',
      key: 'fe_sca',
      width: 250,
    },

    {
      title: 'Pacientes em medidas de conforto ou cuidados paliativos',
      dataIndex: 'paliativos_sca_descritivo',
      key: 'paliativos_sca',
      width: 200,
    },

    {
      title: 'Paciente teve diagnóstico de COVID-19 durante a internação',
      dataIndex: 'covid_sca',
      key: 'covid_sca',
      width: 210,
    }, //

    {
      title: 'Motivo da saída hospitalar',
      dataIndex: 'saida_motivo_sca_descritivo',
      key: 'saida_motivo_sca',
      width: 130,
    },

    {
      title: 'Data da saída',
      dataIndex: 'saida_data_sca',
      key: 'saida_data_sca',
      width: 130,
    },

    {
      title: 'Hora da saída',
      dataIndex: 'saida_hora_sca',
      key: 'saida_hora_sca',
      width: 130,
    },

    {
      title: 'Medicações prescritas na alta: Estatina',
      dataIndex: 'estatina_sca_descritivo',
      key: 'estatina_sca',
      width: 200,
    },

    {
      title: 'Medicações prescritas na alta: Betabloqueador',
      dataIndex: 'bb_sca_descritivo',
      key: 'bb_sca',
      width: 200,
    },

    {
      title: 'Medicações prescritas na alta: iECA/BRA',
      dataIndex: 'iecabra_sca_descritivo',
      key: 'iecabra_sca',
      width: 200,
    },

    {
      title: 'Paciente reinternou em até 30 dias após a saída da instituição',
      dataIndex: 'reinternacao_sca_descritivo',
      key: 'reinternacao_sca',
      width: 200,
    },

    {
      title: 'Reinternação foi por motivo relacionado à SCA',
      dataIndex: 'reinternacao_motivo_sca_descritivo',
      key: 'reinternacao_motivo_sca',
      width: 200,
    },
  ];
};

export default columnSca;
